/*
  STOKE — Reveal al entrar en viewport (IntersectionObserver).

  Dispara la animación una sola vez cuando cada elemento entra en pantalla y deja
  de observarlo. Al estar basado en tiempo (la transición la define el CSS), NO se
  acopla al scroll => sin tirones/rebotes.

  La clase .stoke-anim en <html> ya la ha puesto el head de forma síncrona cuando
  procede (hay IntersectionObserver y no hay prefers-reduced-motion), evitando
  parpadeos. Aquí solo añadimos las clases objetivo y observamos.
*/
(function () {
  if (!document.documentElement.classList.contains('stoke-anim')) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var io = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-revealed');
            obs.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    // Secciones: salta la primera para que el hero aparezca al instante.
    var sections = main.querySelectorAll('.shopify-section');
    sections.forEach(function (el, index) {
      if (index === 0) return;
      el.classList.add('stoke-reveal');
      io.observe(el);
    });

    // Tarjetas de producto: aparición escalonada al hacer scroll.
    main.querySelectorAll('.resource-list__item').forEach(function (el) {
      el.classList.add('stoke-reveal-card');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
